import {
  getResourceMuleVersion,
  getResourceType,
  isHybridApp, isRTFApp,
  Resource as ComponentsResource
} from '@mulesoft/monitoring-center-components/lib/models/resource'
import { DashboardError, DashboardLoadingState } from '@mulesoft/monitoring-center-components'
import { TimeRange } from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt'
import { HybridApplication } from '@mulesoft/monitoring-center-components/lib/models/resource/hybrid'

export type CustomMetricsState = {
  metricList: {
    metrics?: CustomMetric[]
    isLoading: boolean
  }
}

export type CustomMetric = {
  name: string,
  selector: CustomMetricSelector
}

export type CustomMetricSelector = {
  aggregationSelector: {
    aggregations?: string[]
    selected?: string
    isLoading: boolean
  }
  measureSelector: {
    measures?: string[]
    selected?: string
    isLoading: boolean
  }
  dimensionSelector: {
    dimensions?: string[]
    selected?: string
    isLoading: boolean
  }
}

export type LocalStorageCustomMetricSelector = {
  aggregation?: string,
  measure?: string,
  dimension?: string
}

export const customMetricSelectorInitialState = {
  aggregationSelector: {
    aggregations: undefined,
    selected: '',
    isLoading: false
  },
  measureSelector: {
    measures: undefined,
    selected: '',
    isLoading: false
  },
  dimensionSelector: {
    dimensions: undefined,
    selected: '',
    isLoading: false
  }
}

export const getCustomMetricsProps = (resource: ComponentsResource,
                                      range: TimeRange,
                                      onDashboardFunctions: {
                                        onDashboardStateChange: (loading: DashboardLoadingState, uri: string, iframe?: HTMLIFrameElement) => void
                                        onDashboardError: (error: DashboardError) => void
                                      },
                                      isTitanium: boolean,
                                      dashboardType: string) => {
  const organizationId = resource.organizationId
  const environmentId = resource.environmentId
  const resourceId = (isHybridApp(resource) || isRTFApp(resource)) ? resource.name : resource.id.toString()
  const hybridApp = (resource as HybridApplication)
  const hybridTarget = hybridApp.target
  const targetId = hybridTarget && hybridTarget.id
  const resourceType = getResourceType(resource)

  return {
    key: `${organizationId}-${environmentId}-${resourceId}`,
    orgId: organizationId,
    envId: environmentId,
    appId: resourceId,
    rsType: resourceType,
    targetId: targetId,
    onDashboardError: onDashboardFunctions.onDashboardError,
    onDashboardStateChange: onDashboardFunctions.onDashboardStateChange,
    from: range.from,
    to: range.to,
    appMuleVersion: getResourceMuleVersion(resource),
    dashboardType: dashboardType
  }
}
